export class ItemVencimiento {
    acreedor;
    fecha_corte;
    tipo_riesgo;
    saldo_deuda;
    valor_por_vencer;
    no_devenga_intereses;
    valor_vencido;
    demanda_judicial;
    cartera_castigada;
    tiempo_vencido_dias;
    constructor() {
        this.acreedor = "";
        this.fecha_corte = "";
        this.tipo_riesgo = "";
        this.saldo_deuda = 0;
        this.valor_por_vencer = 0;
        this.no_devenga_intereses = "";
        this.valor_vencido = 0;
        this.demanda_judicial = "";
        this.cartera_castigada = "";
        this.tiempo_vencido_dias = 0;
    }
}
